export default "__VITE_ASSET__CEolE8XT__"